import { render, staticRenderFns } from "./AddAdmissionsAssessment.vue?vue&type=template&id=52a30ff4&"
import script from "./AddAdmissionsAssessment.vue?vue&type=script&lang=js&"
export * from "./AddAdmissionsAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports